$(document).ready(function () {

    var section_nav = $('.js-section-nav');

    var links = "";

    $('.js-nav-section').each(function () {

        var title = $(this).attr('data_title');
        var ref = $(this).attr('data_ref');

        links += '<li><span class="js-link-to-section" data_ref="' + ref + '">' + title + '</span></li>';

    });

    section_nav.html(links);


    $('body').on('click', '.js-link-to-section', function () {

        var ref = $(this).attr('data_ref');

        var section = $('.js-nav-section[data_ref=' + ref + ']');

        var scroll_to = section.position().top + $('body').scrollTop();

        console.log(scroll_to);

        $('body').animate({
            scrollTop: scroll_to
        }, 500);

    });

});